import BaseService from "../../../services/BaseService";

class DslDsMappingService extends BaseService{};

export default new DslDsMappingService('health_backend', 'dsl_ds_mappings');